
<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">
              <h1>Seleccionar años a promediar</h1>
              <button @click="$emit('close')">&#x2716;</button>
            </slot>
          </div>
          <div class="modal-body">
            <p>
              Con esta opción es posible generar un mapa promedio a partir de un
              conjunto de mapas anuales, ya sea un período o un conjunto de años
              particulares
            </p>
            <slot name="footer">
              <button
                type="button"
                class="btn btn-success"
                style="width: 100%"
                @click="sendMeanData"
              >
                Generar mapa promedio
              </button>
            </slot>

            <slot name="body2">
              <hr />
              <h4>Intervalo de años</h4>

              <div class="row">
                <vue-slider
                  v-model="posible_values"
                  :width="300"
                  :data="options"
                  :interval="1"
                ></vue-slider>
                <button
                  @click="update_from_interval"
                  type="button"
                  class="btn btn-info"
                  style="width: 100%"
                >
                  Seleccionar intervalo de años
                </button>
                <button
                  @click="selection = []"
                  type="button"
                  class="btn btn-info"
                  style="width: 100%; margin-top: 10px"
                >
                  Limpiar selección
                </button>
              </div>
            </slot>
            <hr />
            <slot name="body">
              <h4>Agregar o eliminar años individuales</h4>

  <multiselect v-model="selection" :options="options" :multiple="true"
  :limitText="count => `y ${count} otros`"
  :close-on-select="false"  :show-labels="false" :limit="5"
  :clear-on-select="false" :preserve-search="true" placeholder="Seleccionar" >


  </multiselect>

            </slot>
          </div>

          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import "vue-select/dist/vue-select.css";
import VueSlider from "vue-slider-component";

import "vue-slider-component/theme/default.css";
import "vue-multiselect/dist/vue-multiselect.min.css";


export default {
  name: "ModalMeanSADA",
  components: {
    VueSlider,
  },
  props: ["options", "waiting", "waiting_msg","current_map_special_name"],
  data() {
    return {
      selection: [],
      posible_values: ["1400", "1430"],
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    update_from_interval() {
      let temp = [];
      let min = this.posible_values[0];
      let max = this.posible_values[1];
      for (let i = min; i <= max; i++) {
        temp.push(i);
      }

      // Quita duplicados y ordena
      temp=Array.from(new Set(temp))
      temp.sort()
      // Los datos se extrasan como str
      temp=temp.map(String)
      this.selection = temp;
    },
    sendMeanData() {



      let test_cont = function (l) {
        let n = l.length;
        let continuo = true;
        for (let i = 0; i < n - 1; i++) {
          continuo = continuo && l[i + 1] - l[i] == 1;
        }
        return continuo;
      };




      if (this.selection.length <= 1) {
        alert("Se debe seleccionar un intervalo mayor a 1");
      } else {
        let url = "./calc_mean_sada_raster";
        const dt = { years_to_query: this.selection };

        this.$emit("update:waiting", true);
        this.$emit("update:waiting_msg", "Calculando raster promedio");

        this.axios
          .post(url, dt, { withCredentials: true })
          .then(() => {
            this.$emit("post_calc")
          })
          .finally(() => {


      let sumary_years = "";
      let order_keys=this.selection;
      let n = order_keys.length;
      if (test_cont(order_keys)) {
        let st = order_keys[0];
        let en = order_keys[n - 1];
        sumary_years = st ? `${st}-${en}` : "";
      } else {
        sumary_years =
          n < 5
            ? order_keys.join(", ")
            : order_keys.slice(0, 3).join(", ") + " ... " + order_keys[n - 1];
      }


            this.$emit("update:current_map_special_name",`años promedio: ${sumary_years}`);
            

            this.$emit("update:waiting", false);
            this.$emit("update:waiting_msg", "");
            this.close();
          });
      }
    },
  },
};
</script>


<style scoped>


/* vs__selected-options  vs__selected */


.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
    height: 800px;
overflow-y: auto;
  width: 600px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}




.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
